import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { useSelector } from "react-redux";
import KmlFileUploader from "../../../../TCPForms/reusableComponents/KmlFileUploader";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { IconButton } from "@mui/material";
import { Loader } from "@egovernments/digit-ui-react-components";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";

const SubStep4 = ({ formData, handleSubTabChange, isEmployee, iframeSrc, setIframeSrc }) => {
  console.log("iframeSRC", iframeSrc);
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const [showError, setShowError] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData?.descriptionOfLand,
    },
  };
  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });

  const onSubmit = (data) => {
    handleSubTabChange(4, data);
  };

  const handlePageLoad = async (fileStoreId) => {
    try {
      let url = iframeSrc;

      if (!url) {
        url = await getDocumentByFileStoreId(fileStoreId, setLoading, true);
        setIframeSrc(url);
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = "location.kml";
      link.click();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDownload = () => {
    if (iframeSrc) {
      const link = document.createElement("a");
      link.href = iframeSrc;
      link.download = "document.pdf"; // Optional: set file name
      link.click();
    } else {
      console.error("File not found.");
    }
  };

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const kmlFile = formData?.documents?.find((doc) => doc?.documentType === "kmlFile");
  console.log("kmlfile", kmlFile, formData);
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">GEO Location</h2>
          </div>

          <div className="formInputContainer common-app-form self-certified custom-upload new-custom-uploader">
            <div className="columnWrapper">
              <InputWrapper
                label="Latitude"
                control={control}
                placeholder="Enter Latitude"
                name="descriptionOfLand.latitude"
                type="textInput"
                mandatory
                defaultValue={formData?.descriptionOfLand?.latitude}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
                maxLength={10}
                disabled={formData?.descriptionOfLand?.latitude}
              />
              {/* {!isEmployee && <KmlFileUploader
                                name={"kmlFile"}
                                label={"KML File"}
                                isMandatory
                                validationMsg={"(.kml file only and Max file Size 10 MB)"}
                                required
                                tab={1}
                                showError={showError}
                                // control={control}
                                maxFiles={1}
                            />} */}
              {!isEmployee && (
                <React.Fragment>
                  {kmlFile && (
                    <div className="download-kml" style={{ display: "flex", alignItems: "center", gap: "280px" }}>
                      <strong>KML File:</strong>
                      <IconButton size="large" color="info" onClick={() => getDocumentByFileStoreId(kmlFile?.fileStoreId, setLoading)}>
                        {loading ? (
                          <div style={{ width: "14px", height: "14px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Loader />
                          </div>
                        ) : (
                          <TravelExploreOutlinedIcon color="primary" sx={{ fontSize: "14px" }} />
                        )}
                      </IconButton>
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
            <div className="columnWrapper">
              <InputWrapper
                label="Longitude"
                control={control}
                placeholder="Enter Longitude"
                name="descriptionOfLand.longitude"
                type="textInput"
                mandatory
                defaultValue={formData?.descriptionOfLand?.longitude}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
                maxLength={10}
                disabled={formData?.descriptionOfLand?.longitude}
              />
            </div>
            <br />
          </div>
        </div>
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(2)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default SubStep4;
